module.exports = __webpack_public_path__ + "static/media/fig_2.404340be.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rezum/fig_2.png
// module id = 613
// module chunks = 0